import { render, staticRenderFns } from "./CrmCreateContactForm.vue?vue&type=template&id=5dd2b695"
import script from "./CrmCreateContactForm.vue?vue&type=script&lang=js"
export * from "./CrmCreateContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports